export default __webpack_public_path__ + "static/media/icon-info-panel-4.64468a9f.svg";